export const APP_ROUTES = {
	HOME: "/",
	LOGIN: "/login",
	FORGET_PASSWORD: "/forget",
	SIGNUP : '/signup',
	BLOGS: '/blog',
	// BLOG_DETAILS: '/blogdetail/:id',
	FAQ: '/faq',
	TROUBLESHOOT : '/troubleshoot',
	ABOUTUS: '/about',
	FAQ_THEME: '/faq/:theme',
	FEATURE: '/features',
	CONTACT: "/contact",
	PRIVACY_POLICY: '/privacyPolicy',
	TERMS_CONDITIONS:'/termsConditions',
	SHIPPING_POLICY: '/shippingPolicy',
	REFUND_POLICY:'/refundPolicy',
	DELETE_ACCOUNT: '/deleteAccount',
	PACKAGE_OPTION: '/esim/:countryName/:bundleId',
};